import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './publicTemplate/style/flexboxgrid.min.css';
import './publicTemplate/style/index.css';
import App from './App';
import { devServiceWorkerCleanup } from './devServiceWorkerCleanup';

// Suppress benign ResizeObserver loop error (common with iframes/flex layouts; does not affect behavior)
const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications';
window.addEventListener('error', (e) => {
  if (e.message === resizeObserverLoopErr) {
    e.stopImmediatePropagation();
    return true;
  }
  return false;
});

const rootElement = document.getElementById('root') as HTMLElement;

void devServiceWorkerCleanup().finally(() => {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
